module.exports = __webpack_public_path__ + "img/logo.1a86e8af.png";